import React, { useState } from 'react';
import { Link } from 'react-router-dom';
const Menu = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  // Menu data
  const menuCategories = [{
    id: 'main-dishes',
    name: 'Main Dishes',
    items: [{
      id: 1,
      name: 'Kare-Kare',
      description: 'A Filipino stew with a thick peanut sauce, oxtail, and vegetables.',
      price: 299.0,
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wfcm5TzpGnGaMfZVrn6ZSk/karekare.jpg',
      popular: true
    }, {
      id: 2,
      name: 'Bulalo',
      description: 'A light-colored soup made by cooking beef shanks and bone marrow with corn, cabbage, green beans and potatoes.',
      price: 320.0,
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xygfVbdEWgWP3jK3z6Uqid/Bulalo.jpg',
      popular: true
    }, {
      id: 3,
      name: 'Sinigang',
      description: 'A sour soup with pork, vegetables, and tamarind.',
      price: 280.0,
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uxM8pHhbUXC3pGWHzJs6Tf/sinigang.jpg',
      popular: false
    }]
  }, {
    id: 'sides',
    name: 'Side Dishes',
    items: [{
      id: 4,
      name: 'Lumpiang Shanghai',
      description: 'Filipino spring rolls filled with ground pork and vegetables.',
      price: 150.0,
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mcmzLGmXiKV1sfomKhiKnu/lumpi.jpg',
      popular: false
    }]
  }, {
    id: 'desserts',
    name: 'Desserts',
    items: [{
      id: 7,
      name: 'Leche Flan',
      description: 'Filipino-style crème caramel made with condensed milk and egg yolks.',
      price: 90.0,
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5xxBshb8UQQM1avDETHe8p/lecheflan.jpg',
      popular: false
    }]
  }, {
    id: 'beverages',
    name: 'Beverages',
    items: [{
      id: 8,
      name: 'Bulalo House Coolers',
      description: 'Refreshing layered drink with flavored syrups, perfect to pair with Filipino dishes.',
      price: 85.0,
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hjDux2hW8aSsDw793FRQPM/489862575_122140821638423180_6935283752305353880_n.jpg',
      popular: true
    }, {
      id: 9,
      name: 'Calamansi Juice',
      description: 'Fresh Filipino citrus juice, sweet and tangy.',
      price: 65.0,
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uoT5jSdYi5K9vA5bdPWizb/calamansi.jpg',
      popular: false
    }]
  }];
  // Filter menu items based on active category
  const getFilteredItems = () => {
    if (activeCategory === 'all') {
      return menuCategories.flatMap(category => category.items);
    } else {
      const category = menuCategories.find(cat => cat.id === activeCategory);
      return category ? category.items : [];
    }
  };
  const [cart, setCart] = useState([]);
  const addToCart = item => {
    const existingItem = cart.find(cartItem => cartItem.id === item.id);
    if (existingItem) {
      setCart(cart.map(cartItem => cartItem.id === item.id ? {
        ...cartItem,
        quantity: cartItem.quantity + 1
      } : cartItem));
    } else {
      setCart([...cart, {
        ...item,
        quantity: 1
      }]);
    }
  };
  return <div className="bg-amber-50 min-h-screen" data-id="element-1442">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1443">
        <div className="text-center mb-12" data-id="element-1444">
          <h1 className="text-4xl md:text-5xl font-bold text-amber-900 mb-4" data-id="element-1445">
            Our Menu
          </h1>
          <p className="text-xl text-amber-800 max-w-3xl mx-auto" data-id="element-1446">
            Explore our authentic Filipino dishes prepared with traditional
            recipes and the finest ingredients.
          </p>
        </div>
        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-1447">
          <button onClick={() => setActiveCategory('all')} className={`px-4 py-2 rounded-full ${activeCategory === 'all' ? 'bg-amber-800 text-white' : 'bg-white text-amber-800 border border-amber-800'}`} data-id="element-1448">
            All Items
          </button>
          {menuCategories.map(category => <button key={category.id} onClick={() => setActiveCategory(category.id)} className={`px-4 py-2 rounded-full ${activeCategory === category.id ? 'bg-amber-800 text-white' : 'bg-white text-amber-800 border border-amber-800'}`} data-id="element-1449">
              {category.name}
            </button>)}
        </div>
        {/* Menu Items */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1450">
          {getFilteredItems().map(item => <div key={item.id} className="bg-white rounded-lg overflow-hidden shadow-md transition-transform hover:scale-105" data-id="element-1451">
              <div className="relative" data-id="element-1452">
                <img src={item.image} alt={item.name} className="w-full h-48 object-cover" data-id="element-1453" />
                {item.popular && <div className="absolute top-0 right-0 bg-amber-800 text-white px-3 py-1 text-sm font-semibold" data-id="element-1454">
                    Popular
                  </div>}
              </div>
              <div className="p-6" data-id="element-1455">
                <h3 className="text-xl font-semibold mb-2 text-amber-900" data-id="element-1456">
                  {item.name}
                </h3>
                <p className="text-amber-800 mb-4 h-16 overflow-hidden" data-id="element-1457">
                  {item.description}
                </p>
                <div className="flex justify-between items-center" data-id="element-1458">
                  <span className="text-lg font-bold text-amber-900" data-id="element-1459">
                    ₱{item.price.toFixed(2)}
                  </span>
                  <button onClick={() => addToCart(item)} className="px-4 py-2 bg-amber-800 text-white rounded hover:bg-amber-900 transition" data-id="element-1460">
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>)}
        </div>
        {/* Cart Notification */}
        {cart.length > 0 && <div className="fixed bottom-4 right-4 bg-amber-800 text-white px-4 py-3 rounded-lg shadow-lg" data-id="element-1461">
            <div className="flex items-center" data-id="element-1462">
              <span className="mr-2" data-id="element-1463">{cart.length} items in cart</span>
              <Link to="/customer" className="px-3 py-1 bg-white text-amber-800 rounded hover:bg-amber-100" data-id="element-1464">
                View Cart
              </Link>
            </div>
          </div>}
      </div>
    </div>;
};
export default Menu;